import { Buffer } from 'buffer';

export class EncodingOperation
{
    static Base64Encode(message: string): string
    {
        return Buffer.from(message).toString("base64");
    }
    static Base64Decode(message: string): string
    {
        return atob(message);
    }
}